import CallingExtensions from '@hubspot/calling-extensions-sdk'
import { IsDevelopment } from './Globals'
import { store } from 'store'
import EventEmitter from './EventEmitter'
import { Events } from './Enums'
import { callTo } from 'store/actions/call'
import { SessionState } from 'sip.js'
import Webphone from './Webphone'

const dispatch = store.dispatch

export const defaultSize = {
    height: 666,
    width: 376
}

export const HubspotCtiState = {
    ready: false,
    endedCallNumber: null,
    engagements: new Map(),
    readyToCall: {
        state: false,
        promise: null, 
        resolve: null,
        reject: null
    }
}

HubspotCtiState.readyToCall.promise = new Promise((resolve, reject) => {
    HubspotCtiState.readyToCall.resolve = resolve
    HubspotCtiState.readyToCall.reject = reject
})

export const HubspotCti = new CallingExtensions({
    debugMode: IsDevelopment,
    eventHandlers: {
        onReady: () => {
            HubspotCtiState.ready = true
        },
        onDialNumber: async (data) => {
            const isLoggedIn = !!store.getState().auth.access_token
            const { phoneNumber } = data

            if(!Webphone.isStarted) {
                await HubspotCtiState.readyToCall.promise
            }
        
            if(isLoggedIn) {
                dispatch(callTo(phoneNumber))
                HubspotCtiState.phoneNumber = phoneNumber
            }
        },
        onEngagementCreated: (data) => {
            const { engagementId } = data
            HubspotCtiState.engagements.set(HubspotCtiState.phoneNumber, engagementId)
        },
        onVisibilityChanged: (data) => {
            const { isHidden } = data

            if (isHidden && HubspotCtiState.endedCallNumber) {
                const engagementId = HubspotCtiState.engagements.get(HubspotCtiState.endedCallNumber)
                const callDetails = engagementId ? { engagementId } : {}
                HubspotCti.callCompleted(callDetails)
                HubspotCtiState.engagements.delete(HubspotCtiState.endedCallNumber)
                HubspotCtiState.endedCallNumber = null
            }
        }
    }
})

HubspotCti.init = () => {}

EventEmitter.on(Events.Login, () => {
    HubspotCti.userLoggedIn()
})

EventEmitter.on(Events.Logout, () => {
    HubspotCti.userLoggedOut()
})

EventEmitter.on(Events.OutgoingCall, (data) => {
    const { number, state } = data

    switch (state) {
        case SessionState.Establishing:
            HubspotCti.outgoingCall({
                createEngagement: false,
                phoneNumber: number
            })
            break
        case SessionState.Established:
            HubspotCti.callAnswered()
            break
        case SessionState.Terminated:
            HubspotCtiState.endedCallNumber = number
            HubspotCti.callEnded()
            break
        default:
            break
    }
})

EventEmitter.on(Events.IncomingCall, (data) => {
    const { number, state } = data

    switch (state) {
        case SessionState.Initial:
            HubspotCti.incomingCall({
                createEngagement: true,
                phoneNumber: number
            })
            break
        case SessionState.Established:
            HubspotCti.callAnswered()
            break
        case SessionState.Terminated:
            HubspotCtiState.endedCallNumber = number
            HubspotCti.callEnded()
            break
        default:
            break
    }
})
